export default class TwitterRequestToken {
  constructor(
    public oauthToken: string,
    public oauthTokenSecret: string,
    public userId: string,
    public screenName: string,
  ) {}
}
